// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_5H_","cls2":"News-cls2_7Px News-cls1_5H_"};